import * as actionTypes from 'modules/mediaLibrary/actionTypes';
import * as mediaActionTypes from 'modules/medias/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} UploadModalReducer  */

/** @type {{UploadModalReducer }} */
const initialState = false;

const open = () => true;
const close = () => initialState;

export default createReducer(initialState, {
  [actionTypes.OPEN_UPLOAD_MODAL]: open,
  [actionTypes.CLOSE_UPLOAD_MODAL]: close,
  [mediaActionTypes.UPLOAD_MEDIAS_SUCCESS]: close,
});
